import angular from 'angular';
import uiRouter from 'angular-ui-router';
import youtubeComponent from './youtube.component';
import videoItem from '../videoItem/videoItem';

let youtubeModule = angular.module('youtube', [
  uiRouter, videoItem
])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps.youtube', {
        url: '/youtube',
        component: 'youtube',
        resolve: {
          videos: (AppsService) => AppsService.videoFeed(),
          $title: () => 'Youtube'
        }
      });
  })
  .component('youtube', youtubeComponent)
  .name;

export default youtubeModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/youtube/youtube.js